import { AdminActivityWebService } from '@linktivity/gds-neo';

export const ActivityTemplateStatus =
  AdminActivityWebService.ActivityTemplateStatus;
export type ActivityTemplateStatus =
  AdminActivityWebService.ActivityTemplateStatus;
export const ActivitySalesStatus = AdminActivityWebService.ActivitypbStatus;
export type ActivitySalesStatus = AdminActivityWebService.ActivitypbStatus;
export const TravelProductCategory =
  AdminActivityWebService.TravelProductCategory;
export type TravelProductCategory =
  AdminActivityWebService.TravelProductCategory;
export const ActivityConfirmationType =
  AdminActivityWebService.ConfirmationType;
export type ActivityConfirmationType = AdminActivityWebService.ConfirmationType;
